import { Link, Image } from '@shopify/hydrogen'
import { useState, useEffect, useRef } from 'react'
import { WishlistIcon, WishlistIconPurple } from './Icon.jsx'
import { useWishlist } from '../../store/modules/client/index.js'
import { numberWithCommas } from '../helper/index.js'
import MiniSpinner from '../elements/MiniSpinner.jsx'

const CarouselProduct = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const imageRef = useRef()
  const { handle, title, images, priceRange } = props.product
  const productWidth = props.productWidth
  const productMinWidth = props.productMinWidth
  const productHeight = props.productHeight
  const price = priceRange.maxVariantPrice.amount

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const [liked, setLiked] = useState(false)
  const {
    addOrRemoveWishlist,
    singleProductSchema,
    giantsWishlist,
    fetchYourWishlist,
  } = useWishlist();

  const checkWishlist = () => {
    let found = false;
    giantsWishlist?.forEach((item) => {
      if (item?.handle === props.product.handle) {
        found = true;
      }
    });
    setLiked(found);
  };

  useEffect(() => {
    checkWishlist();
    fetchYourWishlist();
  }, [giantsWishlist?.length]);
  useEffect(() => {
    checkWishlist();
    fetchYourWishlist();
  }, []);

  const toggleLiked = async () => {
    const selectedProduct = singleProductSchema(props.product)
    addOrRemoveWishlist(selectedProduct)
    setLiked(!liked)
  }

  const newPrice = numberWithCommas(price) + '0'

  useEffect(() => {
    if (imageRef.current && imageRef.current?.firstChild?.complete) {
      setIsLoading(false)
    } 
    else return
  }, [imageRef.current?.firstChild?.src])

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-2 md:justify-between md:gap-0 relative pt-5">
      <div className="flex justify-end w-full">
        <button onClick={toggleLiked} className='absolute z-10 pointer-events-auto'>
          {liked == true ? (
            <>
              <WishlistIconPurple />
            </>
          ) : (
            <>
              <WishlistIcon />
            </>
          )}
        </button>
      </div>
      <Link
        to={`/products/${handle}`}
        className={`bg-transparent flex flex-col items-center md:min-w-[300px] ${productMinWidth} snap-start h-full`}
      >
        <div className={`flex justify-center items-center w-full relative  bg-white ${productHeight}`}>
          {images?.nodes.length && (
            <div className="w-full h-auto flex justify-center items-center relative" ref={imageRef}>
              <Image
                data={images?.nodes[0] ?? images?.nodes[1]}
                width={300}
                height={250}
                alt={title}
                style={{ opacity: isLoading ? 0 : 1, transition: "opacity 0.3s ease-in-out" }}
                className={`md:w-[300px] ${productWidth} object-contain h-full mix-blend-multiply`}
                onLoad={handleImageLoad}
                onError={handleImageLoad}
              />
              {isLoading && (<MiniSpinner/>)}
            </div>
          )}
        </div>
        <div
          className={`w-full flex justify-center gap-1 flex-col ${props.align}`}
        >
          <h3 className="font-overpass-bold sm:text-base text-sm tracking-[-0.82px] text-left text-[#3B4458] w-full">
            {title}
          </h3>
          <div className={`${newPrice === "0.00" ? "hidden" : "flex"} font-overpass-regular sm:text-sm text-xs text-left text-[#3B4458] w-full gap-1 justify-start items-center`}>
            <span className={`${newPrice === "0.00" ? "hidden" : "block"}`}>
              From
            </span>
            <span>R {newPrice}</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CarouselProduct;
